import { Pipe, PipeTransform } from '@angular/core';

/************ Metric unit prefixes  ****************
****************************************************
Text	Symbol	Factor	                    Power
yotta   Y       1000000000000000000000000	10^24
zetta   Z       1000000000000000000000	    10^21
exa     E       1000000000000000000	        10^18
peta    P       1000000000000000	        10^15
tera    T       1000000000000	            10^12
giga    G       1000000000                  10^9
mega    M       1000000                     10^6
kilo    k       1000                        10^3
hecto   h       100                         10^2
deca    da      10                          10^1
(none)  (none)	1                           10^0
deci    d	    0.1                         10^−1
centi   c       0.01                        10^−2
milli   m       0.001                       10^−3
micro   μ       0.000001                    10^−6
nano    n       0.000000001                 10^−9
pico    p       0.000000000001              10^−12
femto   f       0.000000000000001           10^−15
atto    a       0.000000000000000001        10^−18
zepto   z       0.000000000000000000001     10^−21
yocto   y       0.000000000000000000000001  10^−24
****************************************************
 Table extracted from:
    https://en.wikipedia.org/wiki/Metric_prefix
***************************************************/

/***************************************************
 * Formats numbers according to their power of 10
 * scale using a specified number of significant
 * digits (defaults to 3) followed by the prefixed
 * metric unit.
 *
 * The pipe takes a number and optionally 3 parameters:
 *  significantDigits - defaults to 3
 *  useNames - set to one to get the prefix name instead
 * of the symbol
 *  unit - the unit for the number (can be blank)
 *
 * Examples:
 *
 *  {{ 1234 | metricunitprefix:3::'Wh' }}
 *  becomes
 *  1.23kWh (or 1,23kWh depending on the locale)
 *
 *  {{ 0.1234 | metricunitprefix:3::'g' }}
 *  becomes
 *  123mg
 *
 *  {{ 0.1234 | metricunitprefix:3:1:'grams' }}
 *  becomes
 *  123miligrams
 *
 ***************************************************/

@Pipe({ name: 'metricunitprefix' })
export class MetricUnitPrefixPipe implements PipeTransform {
    positivePowerNames = ['', 'kilo', 'mega', 'giga', 'tera', 'peta', 'exa', 'zetta', 'yotta'];
    positivePowerSymbols = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
    negativePowerNames = ['', 'milli', 'micro', 'nano', 'pico', 'femto', 'atto', 'zepto', 'yocto'];
    negativePowerSymbols = ['', 'm', 'μ', 'n', 'p', 'f', 'a', 'z', 'y'];

    transform(value, significantDigits, useNames, unit) {
        if (typeof value === 'number' && value !== 0) {
            const suffixIndex = Math.floor(Math.log10(Math.abs(value)) / 3);
            if (Number.isFinite(suffixIndex) && Math.abs(suffixIndex) < this.positivePowerNames.length) {
                const adjustedValue = value / Math.pow(10, suffixIndex * 3);
                const suffix =
                    suffixIndex >= 0 ?
                        (useNames ? this.positivePowerNames[suffixIndex] : this.positivePowerSymbols[suffixIndex]) :
                        (useNames ? this.negativePowerNames[suffixIndex] : this.negativePowerSymbols[suffixIndex]);
                return new Intl.NumberFormat(undefined, { style: 'decimal', maximumSignificantDigits: significantDigits || 3 }).format(adjustedValue) + suffix + (unit || '');
            }
        }
        return value || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/metric-unit-prefix.pipe.ts